import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';
import { selectIsAuthenticated } from '@/store/auth/authSelectors';
import { auth } from '@/utils/auth';
import logger from '@/utils/logger';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const location = useLocation();

  logger.log('ProtectedRoute - isAuthenticated:', isAuthenticated, 'location:', location.pathname);

  // Check both Redux state AND storage to prevent race conditions during login
  // This handles the case where Redux state hasn't updated yet but token is in storage
  const hasToken = auth.isAuthenticated();
  const shouldAllowAccess = isAuthenticated || hasToken;

  logger.log('ProtectedRoute - hasToken:', hasToken, 'shouldAllowAccess:', shouldAllowAccess);

  if (!shouldAllowAccess) {
    logger.log('Not authenticated, redirecting to /signin');
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  logger.log('Authenticated, rendering protected content');
  return <>{children}</>;
}
